var GroupType;
(function (GroupType) {
    GroupType["treeView"] = "treeView";
    GroupType["checkbox"] = "checkbox";
    GroupType["radio"] = "radio";
    GroupType["button"] = "button";
    GroupType["plain"] = "plain";
})(GroupType || (GroupType = {}));
export default GroupType;
//# sourceMappingURL=groupType.js.map